import React from "react";
import { Star, CheckCircle2 } from "lucide-react";
import { motion } from "framer-motion";

export default function Testimonial({ quote, name, role, avatar, rating = 5, index = 0 }) {
  return (
    <motion.figure
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ duration: 0.6, delay: index * 0.08, ease: [0.22, 1, 0.36, 1] }}
      className="relative p-7 lg:p-8 bg-white rounded-3xl border border-brand-primary/10 hover:border-brand-accent/40 transition-all duration-500 hover:-translate-y-1 hover:shadow-[0_40px_80px_-30px_rgba(15,15,15,0.18)]"
      data-testid={`testimonial-${index}`}
    >
      <div className="star-row mb-5" aria-label={`${rating} estrelas`}>
        {Array.from({ length: 5 }).map((_, i) => (
          <Star key={i} size={16} fill={i < rating ? "#C9B47A" : "transparent"} strokeWidth={1.4} />
        ))}
      </div>
      <blockquote className="font-heading text-2xl text-brand-primary leading-snug mb-7">
        &ldquo;{quote}&rdquo;
      </blockquote>
      <figcaption className="flex items-center gap-3">
        <div
          className="w-12 h-12 rounded-full bg-gradient-to-br from-brand-primary/15 to-brand-accent/20 grid place-items-center font-heading text-lg text-brand-primary flex-shrink-0"
          style={{ backgroundImage: avatar ? `url(${avatar})` : undefined, backgroundSize: "cover" }}
        >
          {!avatar && name?.[0]}
        </div>
        <div>
          <div className="font-semibold text-sm flex items-center gap-1.5">
            {name}
            <CheckCircle2 size={14} className="text-brand-accent" />
          </div>
          <div className="text-xs text-ink-secondary">{role}</div>
        </div>
      </figcaption>
    </motion.figure>
  );
}
